// Function to create the pagination container
function createPaginationContainer({containerID, totalResults,
    numOfPages, resultsPerPage, resultsLabel1, resultsLabel2,
    resultsLabel3, isPaginationWhite}) {

    let container = document.createElement('div');
    container.className = 'rmhc-pagination-container';

    var innerContainer = document.createElement('div');
    innerContainer.className = 'pagination-item';

    containerID.forEach(function (id) {
        $('#' + id).empty();
    });

    var currActive = 0;
    // Create the previous button
    var prev = document.createElement('button');
    prev.className = 'prev disabled';
    var prevImg = document.createElement('img');
    prevImg.alt = 'Previous page';
    prev.appendChild(prevImg);
    innerContainer.appendChild(prev);

    // Create the pages list
    var pages = document.createElement('ol');
    for (var i = 1; i <= numOfPages; i++) {
        var li = document.createElement('li');
        if (i === 1) {
            li.className = 'active';
        }
        var a = document.createElement('a');
        a.href = '#' + i;
        a.setAttribute('aria-label', "Page "+i);
        if (isPaginationWhite) a.style.color = "#FFF";
        else a.style.color = "#000";
        a.textContent = i;
        li.appendChild(a);
        pages.appendChild(li);
    }
    innerContainer.appendChild(pages);

    // Create the next button
    var next = document.createElement('button');
    if (numOfPages <= 1) {
        next.className = 'next disabled';
    }
    else {
        next.className = 'next';
    }
    var nextImg = document.createElement('img');
    nextImg.alt = 'Next page';
    next.appendChild(nextImg);
    innerContainer.appendChild(next);

    // Append the container to the root element
    container.appendChild(innerContainer);

    // Create the <p> element
    var pElement = document.createElement('p');
    pElement.setAttribute('tabindex', '0');
    pElement.className = 'resultsheader';

    //Render pagination color as per value of isPaginationWhite (dark/light)
    if (isPaginationWhite) {
        prevImg.src = '/Content/images/svg/arrow-left-white.svg';
        nextImg.src = 'Content/images/svg/arrow-right-white.svg';
        pElement.style.color = '#FFF';
    }
    else {
        prevImg.src = '/Content/images/svg/page-arrow-left.png';
        nextImg.src = 'Content/images/svg/page-arrow-right.png';
        pElement.style.color = '#000';
    }
    //Create dynamic results labels
    var currentPage = document.createElement('span');
    currentPage.className = "current-page";

    var resultsPerPageSpan = document.createElement('span');
    resultsPerPageSpan.className = "current-result-set";

    var resultsLabelSpan1 = document.createElement('span');
    resultsLabelSpan1.textContent = resultsLabel1;
    resultsLabelSpan1.setAttribute('aria-label', resultsLabel1);

    var resultsLabelSpan2 = document.createElement('span');
    resultsLabelSpan2.textContent = resultsLabel2;
    resultsLabelSpan2.setAttribute('aria-label', resultsLabel2);

    var resultsLabelSpan3 = document.createElement('span');
    resultsLabelSpan3.textContent = resultsLabel3;
    resultsLabelSpan3.setAttribute('aria-label', resultsLabel3);

    var totalResultsSpan = document.createElement('span');
    totalResultsSpan.setAttribute('aria-label', totalResults.toString());
    totalResultsSpan.textContent = totalResults.toString();

    var space = document.createElement('span');
    space.innerHTML = '&nbsp;';
    var clonedSpace1 = space.cloneNode(true);
    var clonedSpace2 = space.cloneNode(true);
    var clonedSpace3 = space.cloneNode(true);
    var clonedSpace4 = space.cloneNode(true);

    // Create results label section by appending labels 
    pElement.appendChild(currentPage);
    pElement.appendChild(space);

    pElement.appendChild(resultsLabelSpan1);
    pElement.appendChild(clonedSpace1);

    pElement.appendChild(resultsPerPageSpan);
    pElement.appendChild(clonedSpace2);

    pElement.appendChild(resultsLabelSpan2);
    pElement.appendChild(clonedSpace3);

    pElement.appendChild(totalResultsSpan);
    pElement.appendChild(clonedSpace4);

    pElement.appendChild(resultsLabelSpan3);

    // Append the <p> element to the container
    container.appendChild(pElement);

    let $container = $(container);
    containerID.forEach(function (id) {
        $('#' + id).each(function () {
            let clonedContainer = $container.clone();
            $(this).append(clonedContainer[0]);
        });
    });

    $(document).ready(function () {
        var CLASS_DISABLED = "disabled", CLASS_ACTIVE = "active", CLASS_SIBLING_ACTIVE = "active-sibling";
        //Initialise containers of pagination
        containerID.forEach(function (id) {
            $('#' + id + ' .rmhc-pagination-container').each(function () {
                initPagination.call(this);
            });
        });

        //Function to initialise pagination
        function initPagination() {
            var $this = $(this);
            updateFindAChapterResultSet(currActive);
            $this.find(".prev").on("click", prevClickHandler);
            $this.find(".next").on("click", nextClickHandler);
            $this.find("li").on("click", function () {
                var $parent = $(this).closest(".rmhc-pagination-container");
                currActive = $parent.find("li").index(this);
                onPaginationButtonClick(currActive);
                updateFindAChapterResultSet(currActive);
                containerID.forEach(function (id) {
                    $('#' + id + ' .rmhc-pagination-container').each(function () {
                        changePage.apply(this);
                    });
                });
            });
        }
        //Function to calculate end of results per page after the label "to"
        function getCurrentPageResultsEndCount(currentPageIndex) {
            currentPageIndex = currentPageIndex + 1;
            return Math.min(resultsPerPage * currentPageIndex, totalResults);
        }

        //Function to calculate start of results per page before the label "to"
        function getCurrentPageResultsStartCount(currentPageIndex) {
            currentPageIndex = currentPageIndex + 1;
            let currentPageResultsStartCount = ((currentPageIndex * resultsPerPage) - resultsPerPage) + 1;
            return currentPageResultsStartCount;
        }

        // Function to update current active page number in result labels
        function updateFindAChapterResultSet(currActive) {
            let currentPageResultsEndCount = getCurrentPageResultsEndCount(currActive);
            let currentPageResultsStartCount = getCurrentPageResultsStartCount(currActive);
            let spanElements = document.querySelectorAll('.current-page');
            spanElements.forEach(function (spanElement) {
                spanElement.textContent = currentPageResultsStartCount.toString();
                spanElement.setAttribute('aria-label', currentPageResultsStartCount.toString());
            });
            let spanElements2 = document.querySelectorAll('.current-result-set');
            spanElements2.forEach(function (spanElement) {
                spanElement.textContent = currentPageResultsEndCount.toString();
                spanElement.setAttribute('aria-label', currentPageResultsEndCount.toString());
            });

        }
        //Function to handle update on click of next button
        function nextClickHandler() {
            currActive++;
            let $parent = $(this).closest(".rmhc-pagination-container");
            changePage.apply($parent);
            onPaginationButtonClick(currActive);
            updateFindAChapterResultSet(currActive);
            containerID.forEach(function (id) {
                $('#' + id + ' .rmhc-pagination-container').each(function () {
                    changePage.apply(this);
                });
            });

        }

        //Function to handle update on click of previous button
        function prevClickHandler() {
            currActive--;
            let $parent = $(this).closest(".rmhc-pagination-container");
            changePage.apply($parent);
            onPaginationButtonClick(currActive);
            updateFindAChapterResultSet(currActive);
            containerID.forEach(function (id) {
                $('#' + id + ' .rmhc-pagination-container').each(function () {
                    changePage.apply(this);
                });
            });
        }
        //Function to update classes on click of pagination links & next/ prev buttons
        function changePage() {
            var $list = $(this).find("li");
            $list.filter("." + CLASS_ACTIVE).removeClass(CLASS_ACTIVE);
            $list.filter("." + CLASS_SIBLING_ACTIVE).removeClass(CLASS_SIBLING_ACTIVE);

            $list.eq(currActive).addClass(CLASS_ACTIVE);

            if (currActive === 0) {
                $(this).find(".prev").addClass(CLASS_DISABLED);
            } else {
                $list.eq(currActive).addClass(CLASS_SIBLING_ACTIVE);
                $(this).find(".prev").removeClass(CLASS_DISABLED);
            }

            if (currActive == ($list.length - 1)) {
                $(this).find(".next").addClass(CLASS_DISABLED);
            } else {
                $(this).find(".next").removeClass(CLASS_DISABLED);
            }

        }
    });
}

window.createPaginationContainer = createPaginationContainer;

